module.exports = __webpack_public_path__ + "img/mansmiling_big.25175a25.jpg";